export enum SourceType {
  REFERENCE_SITE = 'REFERENCE_SITE',
  CLARITY_NODE = 'CLARITY_NODE',
}
